// apps/roleforge-app/src/components/respond/RespondWelcomeCard.tsx
//
// Phase 10 Task 10.3 — modal-style welcome overlay shown until the
// stakeholder sends their first message. Copy follows the project's
// "depth-controlled-quality" framing: NO duration / question-count framing.

interface Props {
  ownerName: string;
  auditWorkspaceName: string;
  onStart: () => void;
}

export function RespondWelcomeCard({ ownerName, auditWorkspaceName, onStart }: Props) {
  return (
    <div className="absolute inset-0 z-10 flex items-center justify-center bg-paper/95 px-6 py-12">
      <div className="max-w-xl rounded-2xl border border-line bg-card p-8 shadow-soft">
        <p className="text-base text-graphite">
          <span className="font-semibold text-ink">{ownerName}</span> invited you to
          weigh in on{' '}
          <span className="font-semibold text-ink">{auditWorkspaceName}</span>.
        </p>
        <p className="mt-4 text-base text-ink">
          I'm the Onboarder — I'll ask you about your work, what you're responsible
          for, and where things get stuck. Your answers help build a picture of how
          the team actually operates.
        </p>
        <p className="mt-4 text-base text-ink">
          The more time you give it, the more useful the result. You can step away
          and come back anytime — this link will pick up where you left off.
        </p>
        <p className="mt-4 text-sm text-graphite">
          What you share will be quoted directly to the person who invited you.
        </p>
        <button
          type="button"
          onClick={onStart}
          className="mt-8 rounded-xl bg-coral px-6 py-3 text-sm font-semibold text-paper hover:opacity-90"
        >
          Start the conversation
        </button>
      </div>
    </div>
  );
}
